



















































































import Vue from 'vue';
/* globals process */
import { api, MEMBER_API_SUB_URLS } from '@/api';
import { ConstructPhoneNumber } from '@/helpers';
import { dialogMaxWidth } from '@/constants';
import { UserModel, MemberPersonalInformationResponseModel } from '@/@types/member';

interface Data {
  dialogMaxWidth: string;
  tokenMethod: number;
  isTokenLoading: boolean;
  tokenCallback: () => {};
  showModal: boolean;
  errorMessageDisplay: boolean;
}

export default Vue.extend({
  name: 'TokenReAuth',
  props: {
    callback: {
      type: Function,
      required: true,
    },
    tokenModal: {
      type: Boolean,
      required: true,
    },
    personalInformation: {
      type: Object as () => MemberPersonalInformationResponseModel,
      required: true,
    },
  },
  data() {
    return {
      dialogMaxWidth,
      tokenMethod: 0,
      isTokenLoading: false,
      tokenCallback: null,
      showModal: false,
      errorMessageDisplay: false,
    };
  },
  watch: {
    tokenModal(val) {
      if (val && this.user.role === 'CSR') {
        this.showModal = false;
        this.$emit('closedTokenModal');
        this.callback();
      } else {
        this.showModal = val;
      }
    },
    showModal(val) {
      if (!val) {
        this.$emit('closedTokenModal');
      }
    },
  },
  methods: {
    resetTokenModal(): void {
      this.showModal = false;

      setTimeout(() => {
        this.tokenMethod = 0;
        this.isTokenLoading = false;
        this.tokenCallback = null;
        this.errorMessageDisplay = false;
      }, 250);
    },
    sendAuthToken(): void {
      this.$emit('sendAuthToken');
      this.isTokenLoading = true;
      api
        .post(
          `${MEMBER_API_SUB_URLS.members}/${this.user.memberId}/token-requests`,
          this.payloadMap[this.tokenMethod],
          {
            headers: {
              'x-api-key': process.env.VUE_APP_TOKEN_API_KEY,
            },
          },
        )
        .then(() => {
          this.resetTokenModal();

          setTimeout(() => {
            this.callback();
          }, 250);
        })
        .catch(() => {
          this.isTokenLoading = false;
          this.errorMessageDisplay = true;
        });
    },
  },
  computed: {
    noOptions(): boolean {
      let noEmail = false,
        noPrimaryPhone = false,
        noSecondaryPhone = false;

      if (
        this.personalInformation.email === null ||
        this.personalInformation.email === ''
      ) {
        noEmail = true;
      }

      if (
        this.primaryPhone === null ||
        this.primaryPhone === ''
      ) {
        noPrimaryPhone = true;
      }

      if (
        this.alternatePhone === null ||
        this.alternatePhone === ''
      ) {
        noSecondaryPhone = true;
      }

      return noEmail && noPrimaryPhone && noSecondaryPhone;
    },
    primaryPhone(): string {
      return ConstructPhoneNumber(this.personalInformation.primaryPhone);
    },
    alternatePhone(): string {
      return ConstructPhoneNumber(this.personalInformation.alternatePhone);
    },
    groupTollFreePhone(): string {
      return this.$store.getters.groupTollFreePhone;
    },
    payloadMap(): any {
      return {
        1: {
          method: 'email',
          address: this.personalInformation.email,
        },
        2: {
          method: 'sms',
          address: this.primaryPhone,
        },
        3: {
          method: 'sms',
          address: this.alternatePhone,
        },
        4: {
          method: 'voice',
          address: this.primaryPhone,
        },
        5: {
          method: 'voice',
          address: this.alternatePhone,
        },
      };
    },
    user(): UserModel {
      return this.$store.getters.user;
    },
  },
});
